import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { About } from '../components/About';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { SeoContent } from '../components/SeoContent';
import { ServiceAreas } from '../components/ServiceAreas';
import { CallCta } from '../components/CallCta';
import { usePageMeta } from '../hooks/usePageMeta';
export function AboutPage() {
  usePageMeta({
    title: "About Mike's Pro Detail | Owner-Operated Mobile Detailing",
    description: "Mike's Pro Detail is an owner-operated, fully mobile car detailing service rated 5 stars on Google and Yelp, serving Camarillo, Oxnard, Ventura, Thousand Oaks and all of Ventura County.",
    path: '/about',
    breadcrumbName: 'About'
  });
  return <main data-id="element-579" data-mp="3dfbxt56z8pfh">
      <PageHeader breadcrumb="About" title="About Mike's Pro Detail" subtitle="A premium, fully mobile, owner-operated auto detailing service proudly serving Ventura County." data-id="element-580" data-mp="1gkyy6ou1bg9h" />
      <About data-id="element-581" data-mp="1bmnrgmz1dlvh" />
      <WhyChooseUs showAboutLink={false} data-id="element-582" data-mp="1bk1j4l4bn2c7" />
      <SeoContent data-id="element-583" data-mp="2evxygjw66691" />
      <ServiceAreas data-id="element-584" data-mp="2evfsuwnmafog" />
      <CallCta data-id="element-585" data-mp="2eybtwturhkh4" />
    </main>;
}